<div class="image-container {{mode}}" [class.use-transition]="useTransition">
	<a (click)="goToVideo(video.slug)" (mousedown)="dragStart()">
		<picture>
			<source media="(min-width: 768px)" [srcset]="video.image" *ngIf="mode != 'portrait'">
			<img [src]="video.cover" *ngIf="mode != 'landscape'" />
		</picture>

		<div class="video-meta">
			<span class="video-title" [innerHTML]="video.title | safeHtml"></span>
			<span class="video-subtitle" [innerHTML]="video.subtitle | safeHtml"></span>
		</div>

		<div class="episode" *ngIf="showEpisodes && video.episode">
			<span>{{ video.episode }}</span>
		</div>

		<div class="gradient"></div>

		<div class="watched" *ngIf="video.watched">
			<span><fa-icon matSuffix [icon]="['fas', 'check']" size="xl"></fa-icon></span>
		</div>
	</a>
</div>